import React from 'react';
import { useTranslation } from 'react-i18next';
import style from './TestInstructions.scss';

const TestInstructions = () => {
  const { t } = useTranslation('common');

  return (
    <div className={style['c-invite__test-instructions']}>
      <h3 className="font-weight-bold">{t('instructions.heading')}</h3>

      <ul>
        <li>{t('instructions.rule_stdin_stdout')}</li>
        <li>{t('instructions.rule_output_verification')}</li>
        <li>{t('instructions.rule_stdin_not_required')}</li>
        <li>{t('instructions.rule_readonly_code')}</li>
        <li>{t('instructions.rule_run_code_unit')}</li>
        <li>{t('instructions.rule_custom_input')}</li>
        <li>{t('instructions.rule_debug_print')}</li>
        <li>{t('instructions.rule_do_not_close_browser')}</li>
      </ul>
    </div>
  );
};

export default TestInstructions;
